import React, { useState, useRef } from 'react';
import InvoiceForm from '../components/InvoiceGenerator/InvoiceForm';
import InvoicePreview from '../components/InvoiceGenerator/InvoicePreview';
import styles from './AdminInvoiceGenerator.module.css';

const AdminInvoiceGenerator = () => {
  const [billedTo, setBilledTo] = useState('');
  const [date, setDate] = useState('');
  const [invoiceNo, setInvoiceNo] = useState('');
  const [items, setItems] = useState([
    { id: Date.now().toString(), description: '', quantity: 1, price: 0 }
  ]);
  const [paymentInfo, setPaymentInfo] = useState('');
  const [footerNote, setFooterNote] = useState('');
  const [contact, setContact] = useState('');
  const [logoUrl, setLogoUrl] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null);

  const updateItem = (id, field, value) => {
    setItems(prev =>
      prev.map(item =>
        item.id === id ? { ...item, [field]: field === 'quantity' || field === 'price' ? parseFloat(value) || 0 : value } : item
      )
    );
  };

  const removeItem = (id) => {
    if (items.length <= 1) return;
    setItems(prev => prev.filter(item => item.id !== id));
  };

  const addItem = () => {
    setItems(prev => [...prev, { id: Date.now().toString(), description: '', quantity: 1, price: 0 }]);
  };

  const subtotal = items.reduce((sum, item) => sum + (item.quantity || 0) * (item.price || 0), 0);
  const cgst = subtotal * 0.025;
  const sgst = subtotal * 0.025;
  const totalWithTax = subtotal + cgst + sgst;

  return (
    <div className={styles.adminInvoiceGenerator}>
      <h2 className={styles.pageTitle}>🧾 Invoice Generator</h2>
      <p className={styles.pageSubtitle}>Create custom invoices for your customers</p>

      <div className={styles.twoColLayout}>
        <div className={styles.formCol}>
          <InvoiceForm
            billedTo={billedTo}
            setBilledTo={setBilledTo}
            date={date}
            setDate={setDate}
            invoiceNo={invoiceNo}
            setInvoiceNo={setInvoiceNo}
            items={items}
            updateItem={updateItem}
            removeItem={removeItem}
            addItem={addItem}
            subtotal={subtotal}
            cgst={cgst}
            sgst={sgst}
            totalWithTax={totalWithTax}
            paymentInfo={paymentInfo}
            setPaymentInfo={setPaymentInfo}
            footerNote={footerNote}
            setFooterNote={setFooterNote}
            contact={contact}
            setContact={setContact}
            logoUrl={logoUrl}
            setLogoUrl={setLogoUrl}
            signatureUrl={signatureUrl}
            setSignatureUrl={setSignatureUrl}
          />
        </div>
        <div className={styles.previewCol}>
          <InvoicePreview
            billedTo={billedTo}
            date={date}
            invoiceNo={invoiceNo}
            items={items}
            subtotal={subtotal}
            cgst={cgst}
            sgst={sgst}
            totalWithTax={totalWithTax}
            paymentInfo={paymentInfo}
            footerNote={footerNote}
            contact={contact}
            logoUrl={logoUrl}
            signatureUrl={signatureUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminInvoiceGenerator;